import { useState, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import annTranTransformation from '../../../assets/img/ann-tran-transformation.jpeg';
import diegoTorresTransformation from '../../../assets/img/diego-torres-transformation.jpeg';
import kushVyasTransformation from '../../../assets/img/kush-vyas-transformation.jpeg';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Zoom from 'react-reveal/Zoom';
import './TestimonialsSection.css';

function TestimonialsSection() {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991);
    const [legendHeading, setLegendHeading] = useState("Ann Tran");
    const [legendSubheading, setLegendSubheading] = useState("\"I think you’ve really helped me hone in on focusing on eating better and my mindset is more being and feeling strong and well balanced than just losing weight!\"");

    const updateIsDesktop = () => {
        setIsDesktop(window.innerWidth > 991);
    };

    useEffect(() => {
        window.addEventListener("resize", updateIsDesktop);
        return () => {
            window.removeEventListener("resize", updateIsDesktop);
        }
    });

    return (
        <div id="testimonials-section">
            <Container fluid>
                <Row>
                    <Col lg={12} className="testimonial-col">
                        <Zoom>
                            <h2 id="testimonials-title">TESTIMONIALS</h2>
                        </Zoom>
                    </Col>
                    <Col lg={12} className="testimonial-col">
                        <Carousel id="testimonials-carousel" width={isDesktop ? "50%" : "100%"} showStatus={false} showThumbs={false}
                            onChange={(index) => {
                                if (index === 0) {
                                    setLegendHeading("Ann Tran");
                                    setLegendSubheading("\"I think you’ve really helped me hone in on focusing on eating better and my mindset is more being and feeling strong and well balanced than just losing weight!\"");
                                } else if (index === 1) {
                                    setLegendHeading("Diego Torres");
                                    setLegendSubheading("\"Working with Dan has been an incredible journey for me. I met him a couple years ago and all the work, all the tips, and everything that I have learned from him has been incredible and I’m so thankful to have him as a coach and as a friend. He puts in the work and he really cares about his clients. Weekly check ups, personalized workouts and diet, and he’s always there when I need his help. Honestly, I can’t ask for anything else.\"");
                                } else {
                                    setLegendHeading("Kush Vyas");
                                    setLegendSubheading("\"After joining with Dan, I learned how to eat better, work harder, and more importantly, train more efficiently to reach my goals. Dan’s professionalism and patience’s during my journey really helped me gain the weight I wanted when I was struggling to bulk before. Through his guidance I am proud to have gained 10 additional pounds!\"");
                                }
                            }} infiniteLoop>
                            <div>
                                <img src={annTranTransformation} alt="Show Posing" />
                            </div>
                            <div>
                                <img src={diegoTorresTransformation} alt="Show Posing" />
                            </div>
                            <div>
                                <img src={kushVyasTransformation} alt="Show Posing" />
                            </div>
                        </Carousel>
                        <div className="externalLegend">
                            <h4 className="external-legend-heading">{legendHeading}</h4>
                            <p className="external-legend-subheading">{legendSubheading}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default TestimonialsSection;